import { render, staticRenderFns } from "./ActiveWoundInfection.vue?vue&type=template&id=c9054d82&"
import script from "./ActiveWoundInfection.vue?vue&type=script&lang=js&"
export * from "./ActiveWoundInfection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports